import React from 'react';
import { cn } from '../../utils/cn';
import Icon from '../AppIcon';

const StatusBadge = ({ status, label, icon, variant = 'default', size = 'md', className }) => {
  const statusVariants = {
    completed: {
      bg: 'bg-green-500/10',
      text: 'text-green-400',
      border: 'border-green-500/30',
      icon: 'CheckCircle',
      iconColor: '#10B981',
    },
    running: {
      bg: 'bg-blue-500/10',
      text: 'text-blue-400',
      border: 'border-blue-500/30',
      icon: 'Loader2',
      iconColor: '#3B82F6',
    },
    pending: {
      bg: 'bg-amber-500/10',
      text: 'text-amber-400',
      border: 'border-amber-500/30',
      icon: 'Clock',
      iconColor: '#F59E0B',
    },
    failed: {
      bg: 'bg-red-500/10',
      text: 'text-red-400',
      border: 'border-red-500/30',
      icon: 'XCircle',
      iconColor: '#EF4444',
    },
    cancelled: {
      bg: 'bg-gray-500/10',
      text: 'text-gray-400',
      border: 'border-gray-500/30',
      icon: 'Ban',
      iconColor: '#6B7280',
    },
    active: {
      bg: 'bg-green-500/10',
      text: 'text-green-400',
      border: 'border-green-500/30',
      icon: 'Zap',
      iconColor: '#10B981',
    },
    success: {
      bg: 'bg-green-500/10',
      text: 'text-green-400',
      border: 'border-green-500/30',
      icon: 'CheckCircle2',
      iconColor: '#10B981',
    },
    warning: {
      bg: 'bg-amber-500/10',
      text: 'text-amber-400',
      border: 'border-amber-500/30',
      icon: 'AlertTriangle',
      iconColor: '#F59E0B',
    },
    error: {
      bg: 'bg-red-500/10',
      text: 'text-red-400',
      border: 'border-red-500/30',
      icon: 'AlertCircle',
      iconColor: '#EF4444',
    },
    info: {
      bg: 'bg-blue-500/10',
      text: 'text-blue-400',
      border: 'border-blue-500/30',
      icon: 'Info',
      iconColor: '#3B82F6',
    },
    default: {
      bg: 'bg-white/10',
      text: 'text-white/70',
      border: 'border-white/20',
      icon: 'Circle',
      iconColor: '#FFFFFF',
    },
  };

  const sizeVariants = {
    sm: {
      padding: 'px-2 py-0.5',
      text: 'text-xs',
      iconSize: 10,
    },
    md: {
      padding: 'px-2.5 py-1',
      text: 'text-xs',
      iconSize: 12,
    },
    lg: {
      padding: 'px-3 py-1.5',
      text: 'text-sm',
      iconSize: 14,
    },
  };

  const variantStyle = statusVariants?.[variant] || statusVariants?.[status] || statusVariants?.default;
  const sizeStyle = sizeVariants?.[size] || sizeVariants?.md;

  const displayIcon = icon || variantStyle?.icon;
  const displayLabel = label || status;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium border',
        variantStyle?.bg,
        variantStyle?.text,
        variantStyle?.border,
        sizeStyle?.padding,
        sizeStyle?.text,
        className
      )}
    >
      {displayIcon && (
        <Icon
          name={displayIcon}
          size={sizeStyle?.iconSize}
          color={variantStyle?.iconColor}
          className={status === 'running' ? 'animate-spin' : ''}
        />
      )}
      {displayLabel}
    </span>
  );
};

export default StatusBadge;